export const paths = {
  login() {
    return '/auth/login';
  },
  me() {
    return '/auth/me';
  },
  changePassword() {
    return '/users/change-password';
  },
  getPermission() {
    return '/pms-permission';
  },

  bookings(page?: number, limit?: number) {
    return `/bookings${page ? `?page=${page}&limit=${limit}` : ''}`;
  },
  allBookings() {
    return `/bookings`;
  },
  bookingsDummy() {
    return `/bookings/dummy`;
  },
  getPendingPostRoomCharge() {
    return `/transactions/pending-post-room-charge`;
  },
  bookingsBatchActions() {
    return `/bookings/booking-batch-actions`;
  },
  bookingDetail(id: number) {
    return `/booking-lines/${id}`;
  },
  updateInvoiceDetails(id: number) {
    return `/booking-lines/${id}/update-invoice-details`;
  },
  updateInvoiceInfo(order_id: number) {
    return `/guests/orders/${order_id}/update-invoice-info`;
  },
  getAvailRoomType(startDate: string, endDate: string) {
    return `/room-types?start_date=${startDate}&end_date=${endDate}`;
  },
  actionCheckIn(id: number) {
    return `/booking-lines/${id}/checkin`;
  },
  actionDuplicateBookingLine(id: number) {
    return `/booking-lines/${id}/duplicate-booking-line`;
  },
  assignCustomer() {
    return `/booking-lines/assign-customer`;
  },
  actionCheckOut(id: number) {
    return `/booking-lines/${id}/checkout`;
  },
  actionChangeDate(id: number) {
    return `/booking-lines/${id}/change-date`;
  },
  payments(id: number) {
    return `/booking-lines/${id}/payments`;
  },
  getCustomers() {
    return '/customers';
  },
  getCustomerById(customerId: number) {
    return `/customer-info/${customerId}`;
  },
  getDataCustomerOCR() {
    return '/customers-image-ocr';
  },
  getRooms() {
    return '/rooms';
  },
  getRoomStatus() {
    return '/room-status';
  },
  cleanRoom() {
    return '/room_clean';
  },
  assignRoom() {
    return '/booking-lines/assign-room';
  },
  changeRoomType() {
    return '/booking-lines/change-room-type';
  },
  exchangeRoom() {
    return '/booking-lines/exchange-room';
  },
  unassignRoom() {
    return '/booking-lines/unassign-room';
  },
  cancelBooking(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/cancel`;
  },
  undoCancelledBooking(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/undo-cancelled`;
  },
  updateExtraInfo(bookingLineId: number) {
    return `booking-lines/${bookingLineId}/update-extra-info`;
  },
  removeService(bookingLineId: number) {
    return `booking-lines/${bookingLineId}/remove-service`;
  },
  postRoomCharge(bookingLineId: number) {
    return `booking-lines/${bookingLineId}/post_room_charge`;
  },
  moveTransaction(guestId: number) {
    return `guests/${guestId}/move-transactions`;
  },
  moveSaleOrder(guestId: number) {
    return `guests/${guestId}/move-sale-order`;
  },
  postPayment(guestId: number) {
    return `guests/${guestId}/post-payment`;
  },
  postRefund(guestId: number) {
    return `guests/${guestId}/post-refund`;
  },
  transactionCodes() {
    return `/transaction_codes`;
  },
  editTransactionNote() {
    return `/guests/transactions/edit-note`;
  },
  cancelTransaction() {
    return `guests/transactions/cancel`;
  },
  undoCancelledTransactions() {
    return `guests/transactions/undo-cancelled-transactions`;
  },
  splitTransactions(guestId: number) {
    return `guests/${guestId}/split-transactions`;
  },
  cancelPayment() {
    return `/cancel-payment`;
  },
  buildTransactionsInvoice() {
    return `/guests/transactions/build-transactions-invoice`;
  },
  retryBuildTransactionsInvoice() {
    return `/guests/orders/minvoice-publish`;
  },
  einvoicePreview(orderId: number) {
    return `/guests/orders/${orderId}/minvoice-preview`;
  },
  einvoiceUpdateCustomer() {
    return `/guests/orders/minvoice-customer-update`;
  },
  einvoiceUpdateCustomerInit() {
    return `/guests/orders/minvoice-init`;
  },
  einvoiceSign() {
    return `/guests/orders/minvoice-sign`;
  },
  getTransactionsPayment() {
    return `/transactions/get-transactions-payment`;
  },
  getTransactionsPaymentAcc() {
    return `/transactions/get-transactions-payment-acc`;
  },
  getTimeline() {
    return `/bookings/timeline`;
  },
  batchAction() {
    return `/booking-lines/batch_actions`;
  },

  getCountries() {
    return '/res/countries';
  },
  getAreas(countryId: number) {
    return `/res/states?country_id=${countryId}`;
  },
  addCustomer() {
    return '/customers';
  },
  sendEmail(bookingId: number) {
    return `/booking-confirm?booking_id=${bookingId}`;
  },
  getBookingConfirmationTemplate(bookingId?: number) {
    return `/get-booking-confirmation-template?booking_id=${bookingId}`;
  },
  sendBookingConfirmation() {
    return `/send-booking-confirmation`;
  },
  getTracking() {
    return `/tracking-logs`;
  },
  getServices() {
    return '/services';
  },
  getBreakfasts(date: string) {
    return `/breakfasts?date=${date}`;
  },
  addServices(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/add-service`;
  },
  changePrices(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/prices`;
  },

  getCleaningCalendar() {
    return `/booking-lines/clean-calendar`;
  },

  fixRoom() {
    return '/room-lock';
  },
  unlockRoom() {
    return '/unlock-room';
  },

  getCompanies() {
    return `/utm/mediums`;
  },
  getSources() {
    return `/utm/sources`;
  },
  getCampaigns() {
    return `/utm/campaigns`;
  },
  getStayingGuests() {
    return '/staying-customers';
  },
  getAllNationality() {
    return '/guests/nationality-statistic';
  },
  getCashFlow() {
    return '/get-cash-payments';
  },
  getTransactionsCashFlow() {
    return '/transactions/get-transactions-cash-payment';
  },
  createExpense() {
    return '/create-payment';
  },
  createExpensesCashTransactionV2() {
    return `/create-expense-cash-transaction`;
  },
  cancelExpenseCashTransactionV2() {
    return `/cancel-expense-cash-transaction`;
  },
  editCashPayment() {
    return `/edit-cash-payment`;
  },
  editExpenseCashTransaction() {
    return `/edit-expense-cash-transaction`;
  },

  getAllBranches() {
    return '/branches';
  },
  getCurrentNightAudit() {
    return '/current-branch';
  },
  finishNightAudit() {
    return '/night-audit';
  },
  autoPostRoomChargeNightAudit() {
    return '/booking-lines/auto-post-room-charge';
  },

  getRoomAvailability() {
    return `/night-audit`;
  },
  getRoomSummary() {
    return `/room-summary`;
  },
  getRoomLock() {
    return `/room-lock`;
  },

  updateBreakfast(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/booking-breakfast`;
  },
  undoCheckIn(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/undo-checkin`;
  },
  undoCheckOut(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/undo-checkout`;
  },
  getTransactions() {
    return `/get-payments`;
  },

  getAllBookingLines(bookingId?: number) {
    return `/bookings/${bookingId}/lines`;
  },
  uploadConfirmation(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/attachments`;
  },
  getReservationForecast() {
    return `/weakly-reservation-forecast`;
  },
  getHouseStatus() {
    return `/house-status`;
  },

  getSubHKRooms() {
    return `/hk/sub/rooms`;
  },
  getHKRooms() {
    return `/hk/rooms`;
  },
  shiftAssign() {
    return `/hk/shift-assign`;
  },
  getPmsUsers() {
    return `/pms-users`;
  },
  getListMinibar() {
    return `/services/minibar`;
  },
  hkCheckMinibar() {
    return `/hk/minibar-check`;
  },
  hkStartCleaning() {
    return `/hk/start-cleaning`;
  },
  hkFinishCleaning() {
    return `/hk/end-cleaning`;
  },
  subHKApproveCleaning() {
    return `/hk/sub/cleaning-approve`;
  },
  subHKFillMinibar() {
    return `/hk/sub/minibar-check`;
  },

  getCurrentBranch() {
    return `/current-branch`;
  },
  getLabels() {
    return `/labels`;
  },
  createAndAssignLabel(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/create-and-assign-label`;
  },
  unassignLabels(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/unassign-labels`;
  },
  createShiftHandover() {
    return `/handover-shifts`;
  },
  getCurrentShiftHandover() {
    return `/handover-shifts/current-shift`;
  },
  getListShiftHandover() {
    return `/handover-shifts`;
  },
  chargePaymentDebt() {
    return `/payments/pay-debt`;
  },
  scanCustomerInfo() {
    return `/customer-info-ocr`;
  },
  warehouseManagement() {
    return `/stock/products`;
  },
  getTravelAgency(id: number) {
    return `/travel-agencies/${id}`;
  },
  travelAgencies() {
    return `/travel-agencies`;
  },
  updateTravelAgency(id: number) {
    return `/travel-agencies/${id}/update`;
  },
  deleteTravelAgency(id: number) {
    return `/travel-agencies/${id}/delete`;
  },

  updateOrderDebitPartner(guestId: number, guestOrderId: number) {
    return `/guests/${guestId}/orders/${guestOrderId}/debit-partner`;
  },

  // Groups
  getGroupBookings() {
    return `/groups`;
  },
  getSubGroupsDetails() {
    return `/subgroups`;
  },
  getGroupBookingDetail(groupId: number) {
    return `/groups/${groupId}`;
  },
  addSubGroup(groupId: number) {
    return `/groups/${groupId}/add-subgroup`;
  },
  createGroupBooking() {
    return `/groups`;
  },
  updateGroupBooking(groupId: number) {
    return `/groups/${groupId}/update`;
  },
  cancelGroupBooking(groupId: number) {
    return `/groups/${groupId}/cancel`;
  },
  generateRooming() {
    return `/groups/rooming`;
  },
  updateSubgroup(subGroupId: number) {
    return `/subgroups/${subGroupId}`;
  },
  changeDateSubgroup(groupId: number) {
    return `/groups/${groupId}/change-date`;
  },
  cancelSubgroup(subGroupId: number) {
    return `/subgroups/${subGroupId}/cancel`;
  },
  roomsFoc() {
    return `/rooms-foc`;
  },
  servicesFoc() {
    return `/services-foc`;
  },
  updateOrCreateBookingLineGuests() {
    return `/booking-line-guest`;
  },
  getConsolidateRevenue() {
    return `/consolidate-revenue`;
  },
  getConsolidateSourceRevenue() {
    return `/consolidate-source-revenue`;
  },
  getConsolidateCampaignRevenue() {
    return `/consolidate-campaign-revenue`;
  },
  getConsolidateSourceRevenueDetails(page?: number, limit?: number) {
    return `/consolidate-source-revenue-details${page ? `?page=${page}&limit=${limit}` : ''}`;
  },
  getAddonServiceTaxes() {
    return `/addon-service-taxes`;
  },
  createDummyBooking(groupId: number) {
    return `/groups/${groupId}/dummy-booking`;
  },
  addDiscount(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/add-discount`;
  },
  addDiscountImage(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/add-discount-image`;
  },
  getBookingDiscount(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/get-booking-discount`;
  },
  getTransactionHistory() {
    return `/transaction-logs`;
  },
  getTransactionsFromOrders() {
    return `/guests/orders/transactions`;
  },
  detailedAnalysisReport() {
    return `/detailed-analysis-report`;
  },
  folioRevenueReport() {
    return `/folio-revenue-report`;
  },
  createSurvey(booking_line_id: number, survey_type: string, lang: string) {
    return `/customer-survey?lang=${lang}&survey_type=${survey_type}&booking_line_id=${booking_line_id}`;
  },
  getMinvoicePreview(order_id: number) {
    return `/guests/orders/${order_id}/minvoice-preview`;
  },
  signMinvoice() {
    return '/guests/orders/minvoice-sign';
  },
  exportPuReport() {
    return `/pu-report`;
  },
  getToursData(page: number, pageSize: number) {
    return `/tours?page=${page}&limit=${pageSize}`;
  },
  getTourDataDetails(tourId: number) {
    return `/tours/${tourId}`;
  },
  updateTourStatus(tourId: number) {
    return `/tours/${tourId}/update-tour-status`;
  },
  getEInvoiceStatus() {
    return `/bookings/e-invoice-status`;
  },
  adjustOrderInvoice() {
    return `/guests/orders/adjust-order`;
  },
  getTransactionDetail(transactionId: number) {
    return `/guests/transactions/${transactionId}`;
  },
  moveBooking(move_booking_id: number, booking_line_ids: string) {
    return `/booking-lines/move-booking?move_booking_id=${move_booking_id}&booking_line_ids=${booking_line_ids}`;
  },
  undoMovedBooking(booking_line_ids: string) {
    return `/booking-lines/undo-moved-booking?booking_line_ids=${booking_line_ids}`;
  },
  createBookingRemind(booking_line_id: number) {
    return `/booking-lines/${booking_line_id}/remind`;
  },
  getBookingReminds(page?: number, pageSize?: number) {
    return `/booking-lines/reminds?page=${page}&limit=${pageSize}`;
  },
  editBookingRemind(remind_id: number) {
    return `/booking-lines/reminds/${remind_id}/update`;
  },
  setMasterRoom(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/set-master-room`;
  },
  unsetMasterRoom(bookingLineId: number) {
    return `/booking-lines/${bookingLineId}/unset-master-room`;
  },
  deleteBookingRemind(remind_id: number) {
    return `/booking-lines/reminds/${remind_id}/delete`;
  },
  getServicesReport(page: number, pageSize: number) {
    return `/services-report?page=${page}&limit=${pageSize}`;
  },
  getCustomersBookings(customerId?: number) {
    return `/bookings/customers/${customerId}`;
  },
  serviceIssuseKinSim(service_id: number) {
    return `/services/${service_id}/issue-esim`;
  },
  serviceGetKinSimCampaigns() {
    return '/services/esim-campaigns';
  },
  serviceGetKinSimUrls(service_id: number) {
    return `/services/${service_id}/esim-urls`;
  },
  getKinSimCampaignDetails(campaign_id: number) {
    return `/services/esim-campaigns/${campaign_id}`;
  },
  createAgencyCmsAccount() {
    return '/auth/agency-user';
  },
  updateAgencyCmsAccount(cmsUserId: string) {
    return `/auth/agency-user/${cmsUserId}`;
  }
};
